import React, { createContext, useContext, useState, ReactNode } from 'react';
import { DownloadHubModel, ImageGroupeModel, LinkModel } from '@/types';

interface DownloadHubContextType {
  downloadHub?: DownloadHubModel;
  setDownloadHub: React.Dispatch<React.SetStateAction<DownloadHubModel | undefined>>;
  setDownloadHubPdfLink: (data: LinkModel) => void;
  setDownloadHubGroupedImages: (data: ImageGroupeModel[]) => void;
}

const DownloadHubContext = createContext<DownloadHubContextType | undefined>(undefined);

export const DownloadHubProvider = ({ children }: { children: ReactNode }) => {
  const [downloadHub, setDownloadHub] = useState<DownloadHubModel | undefined>(undefined);

  const setDownloadHubPdfLink = (pdfLink: LinkModel) => {
    setDownloadHub((prev) => {
      return { ...(prev ?? ({} as DownloadHubModel)), downloadPdfLink: pdfLink };
    });
  };

  const setDownloadHubGroupedImages = (groupedImages: ImageGroupeModel[]) => {
    setDownloadHub((prev) => {
      if (prev?.groupedImages) return prev;
      return { ...(prev ?? ({} as DownloadHubModel)), groupedImages: groupedImages };
    });
  };

  return (
    <DownloadHubContext.Provider
      value={{ downloadHub, setDownloadHub, setDownloadHubPdfLink, setDownloadHubGroupedImages }}
    >
      {children}
    </DownloadHubContext.Provider>
  );
};

export const useDownloadHub = () => {
  const context = useContext(DownloadHubContext);
  if (!context) {
    return {
      downloadHub: undefined,
      setDownloadHub: (() => {}) as any,
      setDownloadHubPdfLink: (() => {}) as any,
      setDownloadHubGroupedImages: (() => {}) as any,
    };
  }
  return context;
};
